<template>
  <div class="col-12 col-md-12 col-lg-8">
    <div class="tit text-center">
      <p>Quanto sua empresa fatura por mês?</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">    
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label class="float-left">Faturamento Mensal</label>
            <input class="form-control form-control-lg" v-focus v-model="faturamentoMensal" type="text" placeholder="R$" required v-mask="'money'"/>
          </div>
          <div class="text-center fixedOptions">
            <button :disabled="faturamentoValido" class="btn btn-lg btn-primary">Próximo<img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Masker from '@/utils/masker'

export default {
  data(){
    const faturamentoMensal = this.solicitacao.Empresa.FaturamentoMensal
    return {
      faturamentoMensal: faturamentoMensal ? faturamentoMensal.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) : null   
    }
  },
  computed: {
    faturamentoValido: function() { return parseFloat(this.faturamentoMensal) <= 0 }
  },
  props: {
    solicitacao: {required: true, type: Object},
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {
        Empresa: {
          FaturamentoMensal: Masker.formatReal(this.faturamentoMensal)
        }
      }
      this.$emit('on-submit', newData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/FaturamentoMensalStep.vue